import { CrmEndpoint } from 'common-module/endpoint';

import { Product } from '../model/product';

export class ProductEndpoint extends CrmEndpoint<Product> {
  search(term: string, params?: any) {
    return this.client.post(
      `${this.endpoint}/search`,
      {
        query: term
      },
      this.getReqOptions({ params })
    );
  }
}
